import { BLink } from './link';
import { pluginFactory } from '../../utils/plugins';
var LinkPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BLink: BLink
  }
});
export { LinkPlugin, BLink };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/link/index.js
// module id = S15m
// module chunks = 86